import React from "react";
import BaseComponent from "./BaseComponent";
import DualListBox from "./DualListBox";
import Input from "./Input";
import Utility from"../utilities/Utility.js";
/**
 * This class manages serialized.intentHandling, which is initialized in KnowledgeBase.normalizeSerialized
 * on application load.
 */
export default class IntentHandling extends BaseComponent {

    constructor(props) {
        super(props);
    }

    setConfig(key, value) {
        if (value === undefined) {
            return;
        }

        switch (key) {
            case "inARowLimit":
            case "xAndOutLimit":
                window.apm.serialized.intentHandling[key] = Number.parseInt(value);
                window.apm.serialized.intentHandling[`${key}LastLocalChange`] = window.apm.timestamp;
                break;

            case "inARowIntents":
            case "xAndOutIntents":
                const { intentIds } = value ?? {};
                const genericKey = key.replace(/Intents$/, ''); // result: 'inARow' or 'xAndOut'

                intentIds.forEach(intentId => {
                    const intentToUpdate = window.apm.serialized.components.intents.find(intent => intent.id === intentId);

                    if (!intentToUpdate) {
                        console.error(`Intent ${intentId} was not found. ${genericKey} update failed.`);
                        return;
                    }

                    intentToUpdate.props.config[genericKey] = !intentToUpdate.props.config[genericKey];
                    intentToUpdate.props.lastLocalChange = window.apm.timestamp;
                });
                break;
        }

        window.apm.setSerializedChanged();
    }

    getConfig(key) {
        return this.props.serialized.intentHandling[key];
    }

    render() {
        const inARowExcluded = Utility.getInARowExcludedIntentIds(this.props.serialized.components.intents);
        const xAndOutExcluded = Utility.getXAndOutExcludedIntentIds(this.props.serialized.components.intents);
        const inARowLeft = [];
        const inARowRight = [];
        const xAndOutLeft = [];
        const xAndOutRight = [];
        const exemptedIntents = ['YES', 'NO', 'WAIT', 'BACK_FROM_WAIT', 'DTMF'];

        // handliing lists should include all application intents and all unique by name como intents
        
        const uniqIntents =Utility.getUniqueIntents(this.props.serialized.components.intents);
        
        uniqIntents.filter(int => exemptedIntents.indexOf(int.name) === -1)
            .forEach(intent => {
            if (inARowExcluded.some(iar => iar === intent.id)) { 
                inARowRight.push({
                    id: intent.id,
                    value: intent.name
                });
            } else {
                inARowLeft.push({
                    id: intent.id,
                    value: intent.name
                });
            }
            if (xAndOutExcluded.some(iar => iar === intent.id)) {
                xAndOutRight.push({
                    id: intent.id,
                    value: intent.name
                });
            } else {
                xAndOutLeft.push({
                    id: intent.id,
                    value: intent.name
                });
            }
        });
        
        // inARowLeft
        inARowLeft.sort((a, b) => {
            if (a.value < b.value) {
                return -1;
              }
              if (a.value > b.value) {
                return 1;
              }
            
              // names must be equal
              return 0;
        });

        // inARowRight
        inARowRight.sort((a, b) => {
            if (a.value < b.value) {
                return -1;
              }
              if (a.value > b.value) {
                return 1;
              }
            
              // names must be equal
              return 0;
        });

        //xAndOutLeft
        xAndOutLeft.sort((a, b) => {
            if (a.value < b.value) {
                return -1;
              }
              if (a.value > b.value) {
                return 1;
              }
            
              // names must be equal
              return 0;
        });
        //xAndOutRight
        xAndOutRight.sort((a, b) => {
            if (a.value < b.value) {
                return -1;
              }
              if (a.value > b.value) {
                return 1;
              }
            
              // names must be equal
              return 0;
        });

        return (<div className="row">
                <div className="col-md-6">
                    <Input 
                        context={this}
                        label="In-a-row count" 
                        tooltip="The number of items the caller must consecutively express the same intent to activate the loop handling modules."
                        valKey={"inARowLimit"}
                        value={this.getConfig("inARowLimit")} 
                        inputRules={{"numberOnly": true}}
                        valRules={{"noEmpty": true}} />
                </div>
                <div className="col-md-12">
                    <DualListBox
                        context={this}
                        label="In-a-row intents"
                        tooltip="Select the intents that trigger the loop handling modules if they are repeated."
                        valKey={"inARowIntents"}
                        leftLabel="Watched"
                        rightLabel="Not to watch"
                        left={inARowLeft}
                        right={inARowRight}
                    />
                </div>
                <div className="col-md-12">
                    <hr/>
                </div>
                <div className="col-md-6">
                    <Input 
                        context={this}
                        label="X-and-out count" 
                        tooltip="The number of times a caller must express the same intent in a non-consecutive manner during the conversation to activate the X-and-Out handling module."
                        valKey={"xAndOutLimit"}
                        value={this.getConfig("xAndOutLimit")} 
                        inputRules={{"numberOnly": true}}
                        valRules={{"noEmpty": true}}/>
                </div>
                <div className="col-md-12">
                    <DualListBox
                        context={this}
                        label="X-and-out intents"
                        tooltip="Select the intents that trigger the X-and-Out handling modules."
                        valKey={"xAndOutIntents"}
                        leftLabel="Watched"
                        rightLabel="Not to watch"
                        left={xAndOutLeft}
                        right={xAndOutRight}
                    />
                </div>
            </div>
        );
    }
}